/**
 * ServiceInfo component for displaying information about services
 * Used in both country pages and service-specific pages
 */
interface ServiceInfoProps {
  countryName: string;
  serviceDisplay?: string;
}

export default function ServiceInfo({ countryName, serviceDisplay }: ServiceInfoProps) {
  const isServiceSpecific = !!serviceDisplay;

  return (
    <div className="pt-4 lg:pt-20 pb-10 space-y-14">
      <div>
        <h2 className="font-semibold text-2xl">
          {isServiceSpecific 
            ? `Free Temporary Numbers for ${serviceDisplay} in ${countryName} - ${serviceDisplay} without phone number`
            : `Free vs Private Numbers in ${countryName}`
          }
        </h2>
        <p className="text-zinc-600 font-medium">
          {isServiceSpecific ? (
            <>
              Using free temporary numbers for {serviceDisplay?.toLowerCase()} without a phone number is
              easy with SMSS.BIZ. Browse our list of available free temp numbers from {countryName}. 
              Copy any of the free SMS numbers provided. Then, simply paste the number wherever you need to
              verify accounts online - popular platforms like {serviceDisplay} and many others.
              <br /><br />
              Our cutting-edge cloud infrastructure means all SMS messages sent to the temporary number you&apos;re 
              using will be instantly received and displayed on our site in real-time, with no need to refresh. 
              You can trust that all of our VOIP numbers are 100% real and actively provisioned weekly, not fake numbers.
              <br /><br />
              Whether you need to verify accounts on social media platforms, register for messaging apps,
              or secure your online identity, our free temporary {countryName} phone numbers provide the perfect solution.
              Choose from our available services above to get started with your preferred platform.
            </>
          ) : (
            <>
              SMSS.BIZ offers both free temporary numbers and private rental numbers in {countryName}. 
              Free numbers are perfect for quick verifications and are shared among multiple users. 
              For enhanced privacy and dedicated use, consider renting a private number that only you can access.
              <br /><br />
              Our free numbers are updated daily and work with most popular services like Gmail, Telegram, 
              Discord, Facebook, Twitter, Instagram, and more. However, since these numbers are public, 
              anyone can see the messages received.
              <br /><br />
              Private numbers offer exclusive access with enhanced security features. These numbers are 
              dedicated to your use only and provide better reliability for important verifications.
              <br /><br />
              Whether you need to verify accounts on social media platforms, register for messaging apps,
              or secure your online identity, our free temporary numbers in {countryName} provide the perfect solution.
              Choose from our available services above to get started with your preferred platform.
            </>
          )}
        </p>
      </div>

      <div>
        <h2 className="font-semibold text-2xl">
          How to Use Free Temporary Numbers in {countryName} for {isServiceSpecific ? serviceDisplay : "Phone"}
        </h2>
        <p className="text-zinc-600 font-medium">
          Using our free temp numbers in {countryName} for {isServiceSpecific ? serviceDisplay?.toLowerCase() : "phone"} is simple:
          <br /><br />
          1. Choose a free temp number from the list above {isServiceSpecific ? "" : "or rent a private number"}
          <br />
          2. Copy the number and use it for {isServiceSpecific ? `${serviceDisplay}` : "on any platform"}
          <br />
          3. Return to our website to view the received messages
          <br />
          {isServiceSpecific ? (
            "4. Messages are displayed in real-time with no need to refresh"
          ) : (
            "4. For private numbers, enjoy exclusive access to your messages"
          )}
          <br /><br />
          All messages are displayed in real-time with no need to refresh. Free temp numbers are 
          automatically purged after 24 hours to maintain privacy.
        </p>
      </div>
    </div>
  );
}
